import { MutationStatus } from '@tanstack/react-query'
import { useState } from 'react'
import DocumentPreviewNew from './DocumentPreviewNew.tsx'
import DocumentUploadNew from './DocumentUploadNew.tsx'

interface Props {
  onContinueClick: (file: File) => void
  status: MutationStatus
  uploadInformation?: React.ReactNode
}

function DocumentUploadSequence(props: Props) {
  const { onContinueClick, status, uploadInformation } = props
  const [image, setImage] = useState<File | null>(null)

  if (image) {
    return (
      <DocumentPreviewNew
        status={status}
        onContinueClick={() => {
          onContinueClick(image)
        }}
        onRetakeClick={() => {
          setImage(null)
        }}
        file={image}
      />
    )
  }

  return (
    <DocumentUploadNew
      uploadInformation={uploadInformation}
      onUpload={(files) => {
        setImage(files[0])
      }}
    />
  )
}

export default DocumentUploadSequence
